import { Tag } from 'farmhub-ui-core';

import { genCensorshipStatus } from 'utils';

interface StatusCellTableDesktopProps {
  status: number;
  name?: string;
}

const StatusCellTableDesktop = ({
  status,
  name = 'hoạt động',
}: StatusCellTableDesktopProps): JSX.Element => {
  const getStatusText = () => {
    switch (status) {
      case 0:
        return `Đang ${name}`;
      case 1:
        return `Dừng ${name}`;
      case 2:
        return `Tạm dừng ${name}`;
      case 3:
        return `Chưa hoàn thành`;
      case 4:
        return `Tạm ẩn`;
      default:
        return '';
    }
  };

  return (
    <Tag
      color={genCensorshipStatus(status).color}
      icon={genCensorshipStatus(status).icon}
      styles={{
        width: 'fit-content',
        alignItems: 'center',
        display: 'flex',
        gap: '6px',
      }}
    >
      {getStatusText()}
    </Tag>
  );
};

export default StatusCellTableDesktop;
